module.exports = __webpack_public_path__ + "img/homedesign1.99c9c03c.png";